// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"770":"d2a6eb4d","983":"32f472e4"}[chunkId] + ".chunk.css";
};